module.exports = __webpack_public_path__ + "assets/img/businesses.922468f3.jpg";